import InputList from './InputList';
import './InputList.scss';

export default InputList;
